export const DELETE_UNPUBLISHED_CHANGES = 'delete-unpublished-changes';
export const PUBLISH_SUCCESS = 'publish-success';
export const PUBLISH_SUCCESS_HIDDEN = 'publish-success-hidden';
export const START_TOUR = 'start-tour';
export const CHANGE_EDITOR_TAB = 'change-editor-tab';
export const EDIT_FORM_NAME = 'edit-form-name';
export const SUBMIT_PREVIEW_FORM = 'submit-preview-form';
export const PUBLISH_FORM = 'publish-form';
export const OPEN_PUBLISH_SIDE_PANEL = 'open-publish-side-panel';
export const PRESSED_NAVIGATION_BACK = 'pressed-navigation-back';
export const UNPUBLISHED_MODAL_GO_BACK = 'unpublished-modal-go-back';
export const EXIT_TO_DASHBOARD = 'exit-to-dashboard';
export const PUBLISH_GO_TO_CTAS = 'publish-go-to-ctas';
export const PUBLISH_GO_TO_CMS = 'publish-go-to-cms';